import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "41",
  fill: "none",
  viewBox: "0 0 40 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M20.833 5.5H13c-2.8 0-4.2 0-5.27.545A5 5 0 0 0 5.545 8.23C5 9.3 5 10.7 5 13.5v14c0 2.8 0 4.2.545 5.27a5 5 0 0 0 2.185 2.185c1.07.545 2.47.545 5.27.545h15.333c1.55 0 2.325 0 2.961-.17a5 5 0 0 0 3.536-3.536c.17-.636.17-1.411.17-2.961m-3.333-15v-10m-5 5h10M17.5 14.666a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0m7.483 5.697L10.885 33.18c-.793.72-1.19 1.081-1.224 1.393-.03.271.073.54.278.72.236.207.771.207 1.843.207h15.645c2.398 0 3.598 0 4.54-.403a5 5 0 0 0 2.63-2.63c.403-.943.403-2.142.403-4.54 0-.808 0-1.211-.088-1.587a3.3 3.3 0 0 0-.623-1.296c-.239-.304-.554-.556-1.184-1.06l-4.662-3.73c-.63-.505-.946-.757-1.293-.846a1.67 1.67 0 0 0-.93.03c-.34.11-.639.382-1.237.925"
    }, null, -1)
  ])))
}
export default { render: render }